(function () {
  'use strict';

  const rules = window.CT_PRO_RULES || {};
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isEnglish = String(document.documentElement.lang || '').toLowerCase().startsWith('en');
  const locale = isEnglish ? 'en-GB' : 'pt-PT';
  const t = (pt, en) => isEnglish ? en : pt;
  const money = new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' });
  const PENDING_KEY = 'ct_b2b_pending_orders_v1';
  const STAGED_KEY = 'ct_b2b_staged_order_v1';
  const KNOWN_ORDERS_KEY = 'ct_b2b_known_orders_v1';

  function ruleFor(sku) {
    return rules[String(sku || '').trim()] || null;
  }

  function showToast(message, isError) {
    let toast = document.querySelector('.ct-b2b-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ct-b2b-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.background = isError ? '#8d2f37' : '';
    toast.hidden = false;
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => { toast.hidden = true; }, 3200);
  }

  async function refreshCartCount() {
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      return cart;
    } catch (error) {
      return null;
    }
  }

  function normalizeQuantity(value, minimum, increment) {
    const min = Math.max(1, Number(minimum) || 1);
    const step = Math.max(1, Number(increment) || 1);
    let quantity = Number(value) || min;
    if (quantity < min) quantity = min;
    const remainder = (quantity - min) % step;
    if (remainder !== 0) quantity += step - remainder;
    return quantity;
  }

  function configureStepper(stepper, rule) {
    if (!stepper) return;
    if (stepper.dataset.stepperReady === 'true') return;
    stepper.dataset.stepperReady = 'true';
    const input = stepper.querySelector('[data-qty-input]');
    const minus = stepper.querySelector('[data-qty-minus]');
    const plus = stepper.querySelector('[data-qty-plus]');
    const fallbackMin = Number(stepper.dataset.minimum || 1);
    const fallbackInc = Number(stepper.dataset.increment || 1);
    const minimum = rule ? Number(rule.minimum || fallbackMin) : fallbackMin;
    const increment = rule ? Number(rule.increment || fallbackInc) : fallbackInc;
    stepper.dataset.minimum = minimum;
    stepper.dataset.increment = increment;
    input.min = minimum;
    input.step = increment;
    input.readOnly = true;
    input.value = normalizeQuantity(input.value, minimum, increment);

    function updateButtons() {
      minus.disabled = Number(input.value) <= minimum;
    }
    minus.addEventListener('click', () => {
      input.value = Math.max(minimum, Number(input.value) - increment);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateButtons();
    });
    plus.addEventListener('click', () => {
      input.value = Number(input.value) + increment;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateButtons();
    });
    updateButtons();
  }

  function configureAllSteppers() {
    document.querySelectorAll('[data-qty-stepper]').forEach((stepper) => {
      const sku = stepper.closest('[data-sku]')?.dataset.sku || stepper.dataset.sku;
      configureStepper(stepper, ruleFor(sku));
    });
  }

  async function addToCart(button) {
    const row = button.closest('[data-pro-item], [data-pro-mobile-item]');
    const variantId = Number(row.dataset.variantId);
    const sku = row.dataset.sku;
    const stepper = row.querySelector('[data-qty-stepper]');
    const input = stepper.querySelector('[data-qty-input]');
    const rule = ruleFor(sku);
    const quantity = normalizeQuantity(input.value, rule?.minimum || 1, rule?.increment || 1);
    input.value = quantity;
    button.disabled = true;
    button.textContent = t('A adicionar…', 'Adding…');
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] })
      });
      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || payload.message || t('Não foi possível adicionar ao pedido.', 'Could not add the product to the order.'));
      }
      await refreshCartCount();
      showToast(quantity + t(' unidades adicionadas ao pedido.', ' units added to the order.'));
    } catch (error) {
      showToast(error.message || t('Não foi possível adicionar ao pedido.', 'Could not add the product to the order.'), true);
    } finally {
      button.disabled = false;
      button.textContent = t('Adicionar', 'Add');
    }
  }


  function readStorage(key, fallback) {
    try {
      const value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Storage can be unavailable in strict private modes. The portal still works without it.
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatPendingDate(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return new Intl.DateTimeFormat(locale, {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    }).format(date);
  }

  function pendingOrders() {
    const expiry = Date.now() - (45 * 24 * 60 * 60 * 1000);
    return readStorage(PENDING_KEY, []).filter((order) => Number(order.createdAt || 0) >= expiry);
  }

  function savePendingOrders(orders) {
    writeStorage(PENDING_KEY, orders.slice(0, 20));
  }

  function updatePendingCounts(count) {
    document.querySelectorAll('[data-pending-count]').forEach((node) => { node.textContent = count; });
  }

  function renderPendingOrders() {
    const orders = pendingOrders();
    const container = document.querySelector('[data-pending-orders]');
    const empty = document.querySelector('[data-pending-empty]');
    updatePendingCounts(orders.length);
    if (!container) return;
    container.innerHTML = orders.map((order) => {
      const items = Array.isArray(order.items) ? order.items : [];
      const itemRows = items.map((item) => (
        '<li><span>' + escapeHtml(item.title) + '</span><strong>' + Number(item.quantity || 0) + ' un.</strong></li>'
      )).join('');
      return '<article class="ct-b2b-pending-order" data-pending-id="' + escapeHtml(order.id) + '">' +
        '<div class="ct-b2b-pending-main"><span class="ct-b2b-order-number">' + escapeHtml(order.reference) + '</span>' +
        '<strong>' + escapeHtml(formatPendingDate(order.createdAt)) + '</strong>' +
        '<small>' + items.length + t(' referência', ' reference') + (items.length === 1 ? '' : 's') + ' · ' + Number(order.units || 0) + t(' unidades', ' units') + '</small></div>' +
        '<div class="ct-b2b-order-status"><span class="is-pending">' + t('Pendente de confirmação','Pending confirmation') + '</span><small>' + t('A aguardar validação comercial','Awaiting commercial validation') + '</small></div>' +
        '<div class="ct-b2b-order-total"><strong>' + money.format(Number(order.totalCents || 0) / 100) + '</strong><small>' + t('total estimado','estimated total') + '</small></div>' +
        '<details class="ct-b2b-pending-details"><summary>' + t('Ver referências','View references') + '</summary><ul>' + itemRows + '</ul></details>' +
        '<button type="button" class="ct-b2b-pending-dismiss" data-dismiss-pending="' + escapeHtml(order.id) + '">' + t('Ocultar','Hide') + '</button>' +
      '</article>';
    }).join('');
    if (empty) empty.hidden = orders.length !== 0;
  }

  function stageCurrentOrder(cart) {
    const lines = Array.from(cart.querySelectorAll('[data-cart-line]'));
    if (!lines.length) return;
    const items = lines.map((line) => {
      const sku = line.dataset.sku || '';
      const rule = ruleFor(sku);
      const quantity = Number(line.querySelector('[data-qty-input]')?.value || line.dataset.quantity || 0);
      return {
        title: line.dataset.title || line.querySelector('h3')?.textContent.trim() || '',
        vendor: line.dataset.vendor || '',
        sku,
        quantity,
        unitCents: Number(line.dataset.unitCents || 0),
        lineCents: Number(line.dataset.lineCents || 0),
        vat: Number(rule?.vat || line.dataset.vat || 13)
      };
    });
    const subtotalCents = items.reduce((sum, item) => sum + item.lineCents, 0);
    const vatCents = items.reduce((sum, item) => sum + Math.round(item.lineCents * item.vat / 100), 0);
    const now = Date.now();
    const date = new Date(now);
    const reference = 'PED-' + date.getFullYear() + String(date.getMonth() + 1).padStart(2, '0') + String(date.getDate()).padStart(2, '0') + '-' + String(date.getHours()).padStart(2, '0') + String(date.getMinutes()).padStart(2, '0');
    const record = {
      id: String(now),
      reference,
      createdAt: now,
      items,
      units: items.reduce((sum, item) => sum + item.quantity, 0),
      subtotalCents,
      vatCents,
      totalCents: subtotalCents + vatCents,
      ordersCountAtSubmit: Number(cart.dataset.ordersCount || 0)
    };
    writeStorage(STAGED_KEY, record);
    if (window.localStorage.getItem(KNOWN_ORDERS_KEY) === null) {
      writeStorage(KNOWN_ORDERS_KEY, record.ordersCountAtSubmit);
    }
  }

  async function promoteSubmittedOrder() {
    const staged = readStorage(STAGED_KEY, null);
    if (!staged) return;
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      if (cart.item_count !== 0) return;
      const orders = pendingOrders();
      if (!orders.some((order) => order.id === staged.id)) orders.unshift(staged);
      savePendingOrders(orders);
      window.localStorage.removeItem(STAGED_KEY);
    } catch (error) {
      // Keep the staged order and retry on the next portal visit.
    }
  }

  function reconcileConfirmedOrders() {
    const app = document.querySelector('[data-professional-app]');
    if (!app) return;
    const currentCount = Number(app.dataset.ordersCount || 0);
    const orders = pendingOrders();
    let knownCount;
    try {
      const stored = window.localStorage.getItem(KNOWN_ORDERS_KEY);
      if (stored === null) {
        knownCount = orders.length ? Math.min(currentCount, ...orders.map((order) => Number(order.ordersCountAtSubmit || 0))) : currentCount;
      } else {
        knownCount = Number(JSON.parse(stored)) || 0;
      }
    } catch (error) {
      knownCount = currentCount;
    }
    const confirmedDelta = Math.max(0, currentCount - knownCount);
    if (confirmedDelta > 0 && orders.length) {
      orders.sort((a, b) => Number(a.createdAt || 0) - Number(b.createdAt || 0));
      orders.splice(0, Math.min(confirmedDelta, orders.length));
      savePendingOrders(orders.reverse());
    }
    writeStorage(KNOWN_ORDERS_KEY, currentCount);
  }

  async function configureOrderTracking() {
    await promoteSubmittedOrder();
    reconcileConfirmedOrders();
    renderPendingOrders();
  }

  function configureProfessionalViews() {
    const app = document.querySelector('[data-professional-app]');
    if (!app) return;

    function currentView() {
      const hash = (window.location.hash || '').replace('#', '').toLowerCase();
      if (hash === 'catalogo' || hash === 'catalog') return 'catalog';
      if (hash === 'condicoes' || hash === 'conditions') return 'conditions';
      if (hash === 'pedidos' || hash === 'orders' || hash === 'historico') return 'orders';
      if (hash === 'perfil' || hash === 'profile' || hash === 'conta') return 'profile';
      return 'dashboard';
    }

    function renderView() {
      const view = currentView();
      app.querySelectorAll('[data-pro-view]').forEach((panel) => {
        panel.hidden = panel.dataset.proView !== view;
      });
      app.querySelectorAll('[data-pro-view-link]').forEach((link) => {
        link.classList.toggle('is-active', link.dataset.proViewLink === view);
      });
      const main = app.querySelector('.ct-b2b-main');
      if (main && window.scrollY > app.offsetTop) main.scrollIntoView({ block: 'start' });
    }

    app.addEventListener('click', (event) => {
      const link = event.target.closest('[data-pro-view-link]');
      if (!link || !app.contains(link)) return;
      const target = link.dataset.proViewLink;
      if (!target) return;
      event.preventDefault();
      const hashes = { dashboard: 'painel', catalog: 'catalogo', orders: 'pedidos', profile: 'perfil', conditions: 'condicoes' };
      const hash = hashes[target] || target;
      if (window.location.hash === '#' + hash) {
        renderView();
      } else {
        window.location.hash = hash;
      }
    });

    window.addEventListener('hashchange', renderView);
    window.addEventListener('popstate', renderView);
    renderView();
  }

  function configureProfessionalCatalog() {
    const catalog = document.querySelector('[data-professional-catalog]');
    if (!catalog) return;
    const rows = Array.from(catalog.querySelectorAll('[data-pro-item]'));
    const mobile = Array.from(catalog.querySelectorAll('[data-pro-mobile-item]'));
    const validSkus = new Set();

    [...rows, ...mobile].forEach((item) => {
      const sku = item.dataset.sku;
      const rule = ruleFor(sku);
      if (!rule || !rule.available) {
        item.remove();
        return;
      }
      validSkus.add(sku);
      item.dataset.producer = (rule.producer || item.dataset.producer || '').toLowerCase();
      item.dataset.region = (rule.region || item.dataset.region || '').toLowerCase();
      const logistics = item.querySelector('[data-logistics]');
      const minimum = item.querySelector('[data-minimum]');
      const vat = item.querySelector('[data-vat]');
      const size = item.querySelector('[data-size]');
      if (logistics) logistics.textContent = rule.logistics || '—';
      if (minimum) minimum.textContent = t('mínimo ', 'minimum ') + rule.minimum + ' ' + t('un.', 'units');
      if (vat) vat.textContent = rule.vat + '%';
      if (size) size.textContent = rule.size || '75 cl';
      configureStepper(item.querySelector('[data-qty-stepper]'), rule);
    });

    const producerSelect = catalog.querySelector('[data-filter-producer]');
    const regionSelect = catalog.querySelector('[data-filter-region]');
    const categorySelect = catalog.querySelector('[data-filter-category]');
    const availabilitySelect = catalog.querySelector('[data-filter-availability]');
    const search = catalog.querySelector('[data-filter-search]');

    function appendOptions(select, values) {
      if (!select) return;
      Array.from(new Set(values.filter(Boolean))).sort((a, b) => a.localeCompare(b, 'pt')).forEach((value) => {
        const option = document.createElement('option');
        option.value = value.toLowerCase();
        option.textContent = value;
        select.appendChild(option);
      });
    }

    const currentRows = Array.from(catalog.querySelectorAll('[data-pro-item]'));
    appendOptions(producerSelect, currentRows.map((row) => row.querySelector('[data-producer-label]')?.textContent.trim()));
    appendOptions(regionSelect, currentRows.map((row) => ruleFor(row.dataset.sku)?.region || row.querySelector('[data-region-label]')?.textContent.trim()));
    appendOptions(categorySelect, currentRows.map((row) => row.dataset.category));

    function matches(item) {
      const q = (search?.value || '').trim().toLowerCase();
      const producer = producerSelect?.value || '';
      const region = regionSelect?.value || '';
      const category = categorySelect?.value || '';
      const availability = availabilitySelect?.value || 'available';
      const haystack = (item.dataset.search || '').toLowerCase();
      return (!q || haystack.includes(q)) &&
        (!producer || item.dataset.producer === producer) &&
        (!region || item.dataset.region === region) &&
        (!category || (item.dataset.category || '').toLowerCase() === category) &&
        (availability === 'all' || item.dataset.available === availability);
    }

    function renderFilters() {
      let visible = 0;
      catalog.querySelectorAll('[data-pro-item], [data-pro-mobile-item]').forEach((item) => {
        const show = matches(item);
        item.hidden = !show;
        if (show && item.hasAttribute('data-pro-item')) visible += 1;
      });
      catalog.querySelectorAll('[data-visible-count]').forEach((node) => { node.textContent = visible; });
      const empty = catalog.querySelector('[data-catalog-empty]');
      if (empty) empty.hidden = visible !== 0;
    }

    [producerSelect, regionSelect, categorySelect, availabilitySelect].forEach((select) => select?.addEventListener('change', renderFilters));
    search?.addEventListener('input', renderFilters);
    renderFilters();
  }

  async function changeCartLine(button) {
    const line = button.closest('[data-cart-line]');
    const key = line.dataset.key;
    const input = line.querySelector('[data-qty-input]');
    const quantity = Number(input.value);
    line.classList.add('is-loading');
    try {
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) throw new Error(t('Não foi possível atualizar o pedido.', 'Could not update the order.'));
      window.location.reload();
    } catch (error) {
      line.classList.remove('is-loading');
      showToast(error.message, true);
    }
  }

  function configureProfessionalCart() {
    const cart = document.querySelector('[data-professional-cart]');
    if (!cart) return;
    const checkoutForm = cart.querySelector('#ct-b2b-checkout-form');
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', (event) => {
        const submitter = event.submitter;
        if (!submitter || submitter.name === 'checkout' || submitter.hasAttribute('data-pro-checkout')) stageCurrentOrder(cart);
      });
    }
    cart.querySelectorAll('[data-cart-line]').forEach((line) => {
      const rule = ruleFor(line.dataset.sku);
      const stepper = line.querySelector('[data-qty-stepper]');
      configureStepper(stepper, rule);
      stepper.querySelector('[data-qty-input]').addEventListener('change', () => changeCartLine(stepper));
    });

    const totals = { 6: 0, 13: 0, 23: 0 };
    cart.querySelectorAll('[data-cart-line]').forEach((line) => {
      const rule = ruleFor(line.dataset.sku);
      const vat = Number(rule?.vat || line.dataset.vat || 13);
      const cents = Number(line.dataset.lineCents || 0);
      totals[vat] = (totals[vat] || 0) + cents;
    });
    let vatTotal = 0;
    Object.keys(totals).forEach((rate) => {
      const amount = totals[rate] * Number(rate) / 100;
      vatTotal += amount;
      const node = cart.querySelector('[data-vat-total="' + rate + '"]');
      if (node) node.textContent = money.format(amount / 100);
    });
    const vatNode = cart.querySelector('[data-vat-estimate]');
    if (vatNode) vatNode.textContent = money.format(vatTotal / 100);
    const subtotal = Number(cart.dataset.subtotalCents || 0);
    const totalNode = cart.querySelector('[data-total-with-vat]');
    if (totalNode) totalNode.textContent = money.format((subtotal + vatTotal) / 100);
  }

  function configureB2BProductPage() {
    document.querySelectorAll('[data-b2b-product-form]').forEach((form) => {
      const sku = form.dataset.sku;
      const rule = ruleFor(sku);
      const stepper = form.querySelector('[data-qty-stepper]');
      configureStepper(stepper, rule);
      const logistics = form.querySelector('[data-product-logistics]');
      if (logistics && rule) logistics.textContent = rule.logistics + ' · ' + t('mínimo ', 'minimum ') + rule.minimum + ' ' + t('un.', 'units') + ' · ' + t('incrementos de ', 'increments of ') + rule.increment;
    });
  }

  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-pro-add]');
    if (add) {
      event.preventDefault();
      addToCart(add);
      return;
    }
    const dismissPending = event.target.closest('[data-dismiss-pending]');
    if (dismissPending) {
      event.preventDefault();
      const id = dismissPending.dataset.dismissPending;
      savePendingOrders(pendingOrders().filter((order) => order.id !== id));
      renderPendingOrders();
      return;
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      const line = remove.closest('[data-cart-line]');
      const input = line.querySelector('[data-qty-input]');
      input.value = 0;
      changeCartLine(remove);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-catalog-total]').forEach((node) => { node.textContent = Object.keys(rules).length; });
    configureProfessionalViews();
    configureAllSteppers();
    configureProfessionalCatalog();
    configureProfessionalCart();
    configureB2BProductPage();
    configureOrderTracking();
  });
}());
